var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PrecificationBaseForm',{attrs:{"busEvent":_vm.busEvent,"formContext":_vm.formContext}})}
var staticRenderFns = []

export { render, staticRenderFns }